import module from 'finanzas/module.js'

function FinanzasClasificarMovimientosService ($http) {
  this.getEmpresas = function () {
    return $http.get('/kendu/finanzas/clasificarmovimientos/traerEmpresas')
  }

  this.getCoindicencias = function (data, cuenta) {
    return $http.post('/kendu/finanzas/clasificarmovimientos/getCoincidencias', {
      data: data,
      cuenta: cuenta,
    }, {
      schema: schema,
    })
  }

  this.clasificarmovimientos = function (OP_ID_Empresa, idCuenta, data) {
    return $http.post('/kendu/finanzas/clasificarmovimientos/clasificarmovimientos', {
      idEmpresaOP: OP_ID_Empresa,
      idCuenta: idCuenta,
      data: data,
    }, {
      schema: schema,
    })
  }

  this.getCoindicenciasMasivo = function (archivo, cuenta, idBanco) {
    return $http.post('/kendu/finanzas/clasificarmovimientos/getCoincidenciasmasivo', {
      archivo: archivo,
      cuenta: cuenta,
      idBanco: idBanco,
    }, {
      schema: schema,
    })
  }

  this.clasificarmovimientomasivo = function (OP_ID_Empresa, idCuenta, data) {
    return $http.post('/kendu/finanzas/clasificarmovimientos/clasificarmovimientomasivo', {
      idEmpresaOP: OP_ID_Empresa,
      idCuenta: idCuenta,
      data: data,
    }, {
      schema: schema,
    })
  }

  this.buscarMovimiento = function (monto, cuenta, fecha) {
    return $http.get('/kendu/finanzas/clasificarmovimientos/buscarmovimiento', {
      params: {
        monto: monto,
        cuenta: cuenta,
        fecha: fecha,
      },
    }, {
      schema: schema,
    })
  }

  var schema = {
    existeenDetallePago: 'boolean',
    Tipo_Cambio: 'number',
    monto: 'number',
    movimiento: {
      monto: 'number',
    },
    empleados: {
      SubTotal: 'number',
      Neto: 'number',
      Deducciones: 'number',
    },
  }
}

module.service('FinanzasClasificarMovimientos', FinanzasClasificarMovimientosService)



// WEBPACK FOOTER //
// ./src/finanzas/_/clasificarmovimientos/services/FinanzasClasificarMovimientos.js